import { PrimaryButton } from '@tymbe/ui-primitives';
import { useFieldState } from 'informed';
import { FavouriteIcon } from '@tymbe/ui-icons';
import { MouseEventHandler } from 'react';
import { AttendanceScope } from './ShiftAttendance/ShiftUnapprovedAttendance';
import Spinner from '../../../components/Spinner';

type ConfirmAttendanceProps = {
  onSubmitSelected: MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
};

const ConfirmAttendanceButton = ({
  onSubmitSelected,
  isLoading,
}: ConfirmAttendanceProps) => {
  const formState = useFieldState<AttendanceScope[]>('applications');
  const checkedRows = formState?.value?.filter((row) => row.selected);

  return (
    <PrimaryButton
      className="flex gap-2 items-center h-10"
      onClick={onSubmitSelected}
      disabled={!checkedRows?.length || isLoading}
    >
      {isLoading
        ? <Spinner show className="size-[18px]" />
        : <FavouriteIcon name="check" className="size-[18px]" />
      }
      Potvrdit vybrané ({checkedRows?.length || 0})

    </PrimaryButton>
  );
};

export default ConfirmAttendanceButton;
